import {
    BasicController,
    BasicModel,
    BasicReconnectCommand,
    CommandController,
    EnvGlobalsHandler,
    IEnvironmentGlobals
} from "@goodgamestudios/core";

import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

import { Poker2WorldSelectionDialog } from "../../view/dialogs/Poker2WorldSelectionDialog";
import { Poker2WorldSelectionDialogProperties } from "../../view/dialogs/Poker2WorldSelectionDialogProperties";
import { Poker2LayoutManager } from "../../view/Poker2LayoutManager";

export class Poker2ReconnectCommand extends BasicReconnectCommand {
    public execute(commandVars: any = null): void {
        super.execute();

        CommandController.instance.executeCommand(BasicController.COMMAND_INITALIZE_CONTROLLER);

        if (this.env.isTest || this.env.isLocal) {
            this.layoutManager.showDialog("Poker2WorldSelectionDialog", new Poker2WorldSelectionDialogProperties());
        } else {
            if (BasicModel.instanceProxy.instanceMap.length <= 1 || this.env.forceInstanceConnect) {
                CommandController.instance.executeCommand(BasicController.COMMAND_CONNECT_CLIENT);
            } else {
                this.layoutManager.showDialog("Poker2WorldSelectionDialog", new Poker2WorldSelectionDialogProperties());
            }
        }
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    private get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
}

classImplementsInterfaces(Poker2ReconnectCommand, "ISimpleCommand");
